<template>
  <div>
    <template v-if="ports !== null">
      <div class="row menubar">
        <input type=text ref="search" placeholder="Zoeken" @keyup="updateSearch" class="searchbar">
        <inputDropdown
          :array="dropdownYears"
          v-model="year"
          displayPrefix="Jaar: "
          style="float: right"
          :cb="yearDropdownCB"
        />
      </div>
      <div class="card">
        <table width=100%>
          <thead class="table-legend">
            <tr>
              <th>#</th>
              <th>Beheerder</th>
              <th>Accounts</th>
              <th>Last position</th>
              <th>Current Intake</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tr
            v-for="port in slice(
              filter(filter(ports, searchFilter), {'year': year}),
              currentPage * resultsPerPage,
              (currentPage + 1) * resultsPerPage
            )"
            :key="port.id"
          >
            <td width=50>{{port.id}}</td>
            <td v-if="port.manager">{{port.manager}}</td><td v-else>Geen beheerder!</td>
            <td v-if="port.clients > 0">{{port.clients}}</td><td v-else>Geen user!</td>
            <td v-if="port.date">
              {{(new Date(port.date)).toLocaleDateString()}}
              <a
                style="cursor: pointer"
                v-if="new Date(port.date) < expireDate"
                @click="closePort(port.id)"
              >
                (close)
              </a>
            </td>
            <td v-else>Geen positie!</td>
            <td v-if="port.completedIntakes">
              {{(new Date(port.completedIntakes[0].date)).toLocaleDateString()}}
            </td>
            <td v-else>Geen intake!</td>
            <template v-if="!port.busyIntakes">
              <td v-if="!port.action_required">
                <button
                  @click="actionRequired(
                    port.id,
                  )"
                  class="secondary"
                >
                  <awesomeIcon icon="exclamation-circle"/> Start actie vereist
                </button>
              </td>
              <td
                v-else
                :title="`Gestart op ${new Date(port.action_required_date).toLocaleDateString()}`"
              >
                <button
                  @click="stopActionRequired(
                    port.id,
                  )"
                  class="secondary"
                >
                  <awesomeIcon icon="ban"/> Stop actie vereist
                </button>
              </td>
            </template>
            <td v-else></td>
            <td v-if="port.busyIntakes">
              <button @click="doOpen(port.busyIntakes[0].id)" class="secondary">
                <awesomeIcon icon="redo-alt"/> Vervolg intake {{port.busyIntakes[0].id}}
              </button>
            </td>
            <td v-else>
              <button
                @click="redoIntake(
                  port.id,
                  port.completedIntakes ? port.completedIntakes[0] : null
                )"
                class="secondary"
              >
                <awesomeIcon icon="clipboard-list"/> Open her-intake!
              </button>
            </td>
          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="filter(
            filter(ports, searchFilter),
            { year: year }
          ).length"
          :resultsPerPage="resultsPerPage"
        />
      </div>
    </template>
    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  slice, filter, reverse, sortBy, groupBy,
} from 'lodash-es';

export default {
  name: 'AdminPorts',
  data() {
    return {
      expireDate: new Date(new Date().setDate((new Date()).getDate() - 7)),
      search: '',
      currentPage: 0,
      resultsPerPage: 20,
      ports: null,
      year: `${(new Date()).getFullYear()}`,
      dropdownYears: null,
    };
  },
  created() {
    this.getAdminPorts();
  },
  methods: {
    filter,
    slice,
    yearDropdownCB() {
      this.currentPage = 0;
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase().trim();
    },
    searchFilter(obj) {
      if (obj.id.toLowerCase().indexOf(this.search) > -1) {
        return true;
      }
      return false;
    },
    doOpen(intake) {
      window.open(`?intake=${intake}`);
    },
    closePort(port) {
      this.sdk.setPortClosed(port, (response) => {
        if (response.status === 200) {
          // eslint-disable-next-line
          alert(response.data.message);
        }
      });
    },
    actionRequired(port) {
      this.$store.state.confirm.toggle({
        text: `Weet u zeker dat u portefeuille ${port} op 'Actie vereist' wilt zetten?`,
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.portActionRequired(port, (response) => {
              if (response.status === 200) {
                this.getAdminPorts();
              } else {
                this.$store.state.confirm.toggle({
                  alert: true,
                  text: `Het is niet gelukt om portefeuille ${port} op 'Actie vereist' te zetten`,
                  cb: () => {},
                });
              }
            });
          }
        },
      });
    },
    stopActionRequired(port) {
      this.$store.state.confirm.toggle({
        text: `Weet u zeker dat u de 'Actie vereist' van portefeuille ${port} stop wilt zetten?`,
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.stopActionRequired(port, (response) => {
              if (response.status === 200) {
                this.getAdminPorts();
              } else {
                this.$store.state.confirm.toggle({
                  alert: true,
                  text: `Het is niet gelukt om de 'Actie vereist' van portefeuille ${port} stop te zetten`,
                  cb: () => {},
                });
              }
            });
          }
        },
      });
    },
    redoIntake(port) {
      this.sdk.redoIntake(port, (response) => {
        window.open(`?intake=${response.data.intake}`);
        this.getAdminPorts();
      });
    },
    getAdminPorts() {
      this.sdk.getAdminPorts((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].year = response.data[i].date ? `${(new Date(response.data[i].date)).getFullYear()}` : '-';
          }
          this.ports = reverse(sortBy(response.data, (o) => {
            const orders = [];
            orders.push(o.completedIntakes ? new Date(o.completedIntakes[0].date) : null);
            orders.push(o.busyIntakes ? new Date(o.busyIntakes[0].date) : null);
            orders.push(o.date);
            return orders;
          }));
          this.dropdownYears = Object.keys(groupBy(this.ports, 'year'));
          this.dropdownYears = this.dropdownYears.map((key) => ({ value: key }));
          this.$nextTick(() => {
            this.resultsPerPage = 20;
          });
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style scoped>
  .searchbar {
    width: 300px;
    float: left;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .secondary {
    padding: 0 10px;
    float: right;
  }
</style>
